import { MouseEvent, ReactNode, forwardRef, useState } from "react";

import { MenuItem, MenuItemProps, Popover, PopoverProps } from "@mui/material";

const NAME = "MenuItemPopover";

export type MenuItemPopoverProps = MenuItemProps;

export const MenuItemPopover = forwardRef<
  HTMLLIElement,
  MenuItemPopoverProps & {
    popover: ReactNode;
    popoverProps?: Partial<PopoverProps>;
  }
>(({ onClick, popover, popoverProps, ...menuItemProps }, menuItemRef) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLLIElement>(null);

  const handleClick = (e: MouseEvent<HTMLLIElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    onClick?.(e);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <MenuItem onClick={handleClick} ref={menuItemRef} {...menuItemProps} />
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        onClose={handleClose}
        open={open}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        {...popoverProps}
      >
        {popover}
      </Popover>
    </>
  );
});
MenuItemPopover.displayName = NAME;
